// src/pages/AccountDashboard.jsx - DÜZELTİLMİŞ ÇIKIŞ FONKSİYONU
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import { useAuth } from '../components/ProtectedRoute';
import {
  User, ShoppingBag, Heart, MapPin, CreditCard,
  Settings, LogOut, Package, Clock, ArrowLeft
} from 'lucide-react';
import toast from 'react-hot-toast';
import pnglogo from '../assets/tronalogo.png';

export default function AccountDashboard() {
  const navigate = useNavigate();
  const { user, isAdmin } = useAuth();

  const handleLogout = async () => {
    try {
      console.log('════════════════════════════════');
      console.log('🚪 ÇIKIŞ YAPILIYOR...');
      console.log('📧 Mevcut kullanıcı:', auth.currentUser?.email);
      console.log('🆔 UID:', auth.currentUser?.uid);
      console.log('════════════════════════════════');

      // 1. Firebase Auth'dan çıkış (EN ÖNEMLİSİ!)
      await signOut(auth);

      console.log('✅ Firebase signOut tamamlandı');
      console.log('📧 Auth durumu (sonra):', auth.currentUser); // NULL olmalı

      // 2. SessionStorage'ı TEMİZLE (visitor tracking için kritik!)
      sessionStorage.clear();
      console.log('✅ SessionStorage temizlendi');

      // 3. localStorage'dan sadece auth bilgilerini temizle
      // ⚠️ CART ve WISHLIST'i SİLME!
      const cartData = localStorage.getItem('cart');
      const wishlistData = localStorage.getItem('wishlist');

      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('userToken');
      localStorage.removeItem('userName');
      localStorage.removeItem('userEmail');
      localStorage.removeItem('userId');
      localStorage.removeItem('user');

      console.log('✅ Auth verileri temizlendi');
      console.log('💾 Cart ve Wishlist korundu');

      toast.success('Çıkış yapıldı');

      // 4. Sayfayı yenile (mecburi - React state'ini sıfırlamak için)
      console.log('🔄 Sayfa yenileniyor...');
      
      setTimeout(() => {
        window.location.href = '/';
      }, 300); // 500ms → 300ms (daha hızlı)

    } catch (error) {
      console.error('❌ ÇIKIŞ HATASI:', error);
      console.error('   Hata kodu:', error.code);
      console.error('   Hata mesajı:', error.message);
      
      toast.error('Çıkış yapılırken hata oluştu');

      // Hata olsa bile FORCE temizlik
      try {
        await signOut(auth); // Tekrar dene
      } catch {}
      
      sessionStorage.clear();
      
      // localStorage'dan sadece auth verilerini sil
      localStorage.removeItem('isLoggedIn');
      localStorage.removeItem('userToken');
      localStorage.removeItem('userName');
      localStorage.removeItem('userEmail');
      localStorage.removeItem('userId');
      localStorage.removeItem('user');
      
      console.log('🔄 Force reload yapılıyor...');
      window.location.href = '/';
    }
  };

  if (!user) {
    navigate('/account');
    return null;
  }

  const menuItems = [
    { icon: <ShoppingBag size={20} />, title: 'Siparişlerim', desc: 'Geçmiş siparişlerinizi görüntüleyin', path: '/orders' },
    { icon: <Heart size={20} />, title: 'Favorilerim', desc: 'Beğendiğiniz ürünler', path: '/wishlist' },
    { icon: <MapPin size={20} />, title: 'Adreslerim', desc: 'Teslimat adreslerini yönetin', path: '/addresses' },
    { icon: <CreditCard size={20} />, title: 'Ödeme Yöntemlerim', desc: 'Kayıtlı kartlarınız', path: '/payment-methods' },
    { icon: <User size={20} />, title: 'Hesap Bilgilerim', desc: 'Profil bilgilerinizi düzenleyin', path: '/profile' },
    { icon: <Settings size={20} />, title: 'Ayarlar', desc: 'Bildirim ve gizlilik ayarları', path: '/settings' }
  ];

  return (
    <div className="account-dashboard">
      <Style />

      <div className="dashboard-header">
        <div className="container">
          <button className="back-btn" onClick={() => navigate('/')}>
            <ArrowLeft size={20} />
            <span>Anasayfa</span>
          </button>
          <div className="header-logo" onClick={() => navigate('/')}>
            <img src={pnglogo} alt="Trona" />
          </div>
        </div>
      </div>

      <div className="container">
        <div className="dashboard-grid">
          <aside className="dashboard-sidebar">
            <div className="user-info-card">
              <div className="user-avatar">
                <User size={32} />
              </div>
              <div className="user-details">
                <h3>{user.displayName || 'Kullanıcı'}</h3>
                <p>{user.email}</p>
              </div>
            </div>

            {isAdmin && (
              <button
                className="admin-btn"
                onClick={() => navigate('/admin')}
              >
                <Settings size={18} />
                <span>Admin Paneli</span>
              </button>
            )}

            <button className="logout-btn" onClick={handleLogout}>
              <LogOut size={18} />
              <span>Çıkış Yap</span>
            </button>
          </aside>

          <main className="dashboard-main">
            <div className="welcome-section">
              <h1>Hoş Geldiniz, {user.displayName || 'Kullanıcı'}!</h1>
              <p>Hesabınızı buradan yönetebilirsiniz</p>
            </div>

            <div className="stats-grid">
              <div className="stat-card">
                <div className="stat-icon">
                  <ShoppingBag size={24} />
                </div>
                <div className="stat-content">
                  <h4>Toplam Sipariş</h4>
                  <p className="stat-value">0</p>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">
                  <Package size={24} />
                </div>
                <div className="stat-content">
                  <h4>Bekleyen Sipariş</h4>
                  <p className="stat-value">0</p>
                </div>
              </div>
              <div className="stat-card">
                <div className="stat-icon">
                  <Heart size={24} />
                </div>
                <div className="stat-content">
                  <h4>Favori Ürün</h4>
                  <p className="stat-value">0</p>
                </div>
              </div>
            </div>

            <div className="menu-grid">
              {menuItems.map((item, index) => (
                <div
                  key={index}
                  className="menu-card"
                  onClick={() => toast.info('Bu özellik yakında eklenecek')}
                >
                  <div className="menu-icon">
                    {item.icon}
                  </div>
                  <div className="menu-content">
                    <h3>{item.title}</h3>
                    <p>{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="recent-orders">
              <h2>Son Siparişler</h2>
              <div className="empty-state">
                <Clock size={48} />
                <h3>Henüz siparişiniz yok</h3>
                <p>Alışverişe başlamak için ürünleri keşfedin</p>
                <button className="primary-btn" onClick={() => navigate('/')}>
                  Alışverişe Başla
                </button>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

function Style() {
  return (
    <style>{`
      * { margin: 0; padding: 0; box-sizing: border-box; }

      .account-dashboard {
        min-height: 100vh;
        background: #f8f9fa;
      }

      .container {
        max-width: 1320px;
        margin: 0 auto;
        padding: 0 20px;
      }

      .dashboard-header {
        background: #fff;
        padding: 20px 0;
        box-shadow: 0 2px 8px rgba(0,0,0,0.05);
        margin-bottom: 40px;
      }

      .dashboard-header .container {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }

      .back-btn {
        display: flex;
        align-items: center;
        gap: 8px;
        background: none;
        border: none;
        color: #495057;
        font-size: 14px;
        cursor: pointer;
        padding: 8px 12px;
        border-radius: 8px;
        transition: all 0.2s;
      }

      .back-btn:hover {
        background: #f8f9fa;
        color: #E5332A;
      }

      .header-logo {
        cursor: pointer;
      }

      .header-logo img {
        height: 40px;
      }

      .dashboard-grid {
        display: grid;
        grid-template-columns: 300px 1fr;
        gap: 32px;
        margin-bottom: 40px;
      }

      .dashboard-sidebar {
        display: flex;
        flex-direction: column;
        gap: 16px;
      }

      .user-info-card {
        background: #fff;
        padding: 24px;
        border-radius: 16px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.04);
        display: flex;
        align-items: center;
        gap: 16px;
      }

      .user-avatar {
        width: 64px;
        height: 64px;
        background: linear-gradient(135deg, #E5332A, #ff4436);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        flex-shrink: 0;
      }

      .user-details h3 {
        font-size: 18px;
        margin-bottom: 4px;
      }

      .user-details p {
        font-size: 13px;
        color: #868e96;
      }

      .admin-btn, .logout-btn {
        width: 100%;
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 14px 20px;
        border: none;
        border-radius: 12px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
      }

      .admin-btn {
        background: linear-gradient(135deg, #E5332A, #ff4436);
        color: #fff;
      }

      .admin-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(229, 51, 42, 0.3);
      }

      .logout-btn {
        background: #f8f9fa;
        color: #495057;
      }

      .logout-btn:hover {
        background: #e9ecef;
        color: #E5332A;
      }

      .dashboard-main {
        display: flex;
        flex-direction: column;
        gap: 32px;
      }

      .welcome-section {
        background: linear-gradient(135deg, #E5332A, #ff4436);
        padding: 40px;
        border-radius: 20px;
        color: #fff;
      }

      .welcome-section h1 {
        font-size: 32px;
        margin-bottom: 8px;
      }

      .welcome-section p {
        font-size: 16px;
        opacity: 0.9;
      }

      .stats-grid {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
      }

      .stat-card {
        background: #fff;
        padding: 24px;
        border-radius: 16px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.04);
        display: flex;
        align-items: center;
        gap: 16px;
      }

      .stat-icon {
        width: 56px;
        height: 56px;
        background: #f8f9fa;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #E5332A;
        flex-shrink: 0;
      }

      .stat-content h4 {
        font-size: 13px;
        color: #868e96;
        margin-bottom: 4px;
      }

      .stat-value {
        font-size: 24px;
        font-weight: 800;
        color: #2B2B2B;
      }

      .menu-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
      }

      .menu-card {
        background: #fff;
        padding: 24px;
        border-radius: 16px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.04);
        display: flex;
        gap: 16px;
        cursor: pointer;
        transition: all 0.2s;
      }

      .menu-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(0,0,0,0.1);
      }

      .menu-icon {
        width: 48px;
        height: 48px;
        background: linear-gradient(135deg, #fff5f5, #ffe8e8);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #E5332A;
        flex-shrink: 0;
      }

      .menu-content h3 {
        font-size: 16px;
        margin-bottom: 4px;
      }

      .menu-content p {
        font-size: 13px;
        color: #868e96;
      }

      .recent-orders {
        background: #fff;
        padding: 32px;
        border-radius: 16px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.04);
      }

      .recent-orders h2 {
        font-size: 24px;
        margin-bottom: 24px;
      }

      .empty-state {
        text-align: center;
        padding: 60px 20px;
        color: #868e96;
      }

      .empty-state svg {
        margin-bottom: 16px;
      }

      .empty-state h3 {
        font-size: 18px;
        margin-bottom: 8px;
        color: #2B2B2B;
      }

      .empty-state p {
        margin-bottom: 24px;
      }

      .primary-btn {
        background: #E5332A;
        color: #fff;
        border: none;
        padding: 12px 32px;
        border-radius: 12px;
        font-size: 14px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
      }

      .primary-btn:hover {
        background: #c72a22;
        transform: translateY(-1px);
      }

      @media (max-width: 992px) {
        .dashboard-grid {
          grid-template-columns: 1fr;
        }

        .menu-grid {
          grid-template-columns: 1fr;
        }

        .stats-grid {
          grid-template-columns: 1fr;
        }
      }

      @media (max-width: 576px) {
        .welcome-section {
          padding: 24px;
        }

        .welcome-section h1 {
          font-size: 24px;
        }

        .back-btn span {
          display: none;
        }
      }
    `}</style>
  );
}